var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Tracking2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3.19995C14.28 3.19995 6.40002 11.08 6.40002 20.8C6.40002 32.3743 17.8445 37.9166 19.2781 39.2062C20.7421 40.523 21.9495 43.4732 22.4375 45.1468C22.6743 45.9596 23.3408 46.3698 24 46.3874C24.6608 46.3682 25.3257 45.958 25.5625 45.1468C26.0505 43.4732 27.2579 40.5246 28.7219 39.2062C30.1555 37.9166 41.6 32.3743 41.6 20.8C41.6 11.08 33.72 3.19995 24 3.19995ZM17.6 12.8H30.4C31.2832 12.8 32 13.5168 32 14.4V27.1999C32 28.0831 31.2832 28.7999 30.4 28.7999H17.6C16.7168 28.7999 16 28.0831 16 27.1999V14.4C16 13.5168 16.7168 12.8 17.6 12.8ZM20.8 16V17.6H27.2V16H20.8Z",
    fill: "#F8FBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 12.8H30.4C31.2832 12.8 32 13.5168 32 14.4V27.1999C32 28.0831 31.2832 28.7999 30.4 28.7999H17.6C16.7168 28.7999 16 28.0831 16 27.1999V14.4C16 13.5168 16.7168 12.8 17.6 12.8ZM20.8 16V17.6H27.2V16H20.8Z",
    fill: "#FFD708"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Tracking2);
export default __webpack_public_path__ + "static/media/icons8-tracking 2.0050617500895918e86c11786d412900.svg";
export { ForwardRef as ReactComponent };